import { z } from "zod";

export const SizeGuideBrasChartsSchema = z.object({
  instructionIcons: z.array(
    z.object({
      filename: z.string(),
      alt: z.string().optional(),
    }),
  ),
  bandTableIcon: z.object({
    filename: z.string(),
    alt: z.string().optional(),
  }),
  cupTableIcon: z.object({
    filename: z.string(),
    alt: z.string().optional(),
  }),
  brasBandTable: z.object({
    thead: z.array(z.object({ value: z.string() })),
    tbody: z.array(
      z.object({
        body: z.array(z.object({ value: z.string() })),
      }),
    ),
  }),
  brasCupTable: z.object({
    thead: z.array(z.object({ value: z.string() })),
    tbody: z.array(
      z.object({
        body: z.array(z.object({ value: z.string() })),
      }),
    ),
  }),
});

export const SizeGuidePantyChartsSchema = z.object({
  pantiesUpdatedTable: z.object({
    thead: z.array(z.object({ value: z.string() })),
    tbody: z.array(
      z.object({
        body: z.array(z.object({ value: z.string() })),
      }),
    ),
  }),
  pantiesUpdatedDoubleSizeTable: z.object({
    thead: z.array(z.object({ value: z.string() })),
    tbody: z.array(
      z.object({
        body: z.array(z.object({ value: z.string() })),
      }),
    ),
  }),
});

export const SizeGuideTopSwimwearCamisoleChartSchema = z.object({
  swimBottomUpdatedTable: z.object({
    thead: z.array(z.object({ value: z.string() })),
    tbody: z.array(
      z.object({
        body: z.array(z.object({ value: z.string() })),
      }),
    ),
  }),
});

export type SizeGuideTab =
  | "bra"
  | "panty"
  | "swimwear"
  | "stockings"
  | "camisoles";

export interface SizeGuideData {
  countries?: string[];
  brasIcon?: {
    filename: string;
    alt?: string;
  };
  pantiesIcon?: {
    filename: string;
    alt?: string;
  };
  swimIcon?: {
    filename: string;
    alt?: string;
  };
  stockingsIcon?: {
    filename: string;
    alt?: string;
  };
  camisolesIcon?: {
    filename: string;
    alt?: string;
  };
  bandTableIcon: {
    filename: string;
    alt?: string;
  };
  cupTableIcon: {
    filename: string;
    alt?: string;
  };
  stockingsTable: {
    thead: Array<{ value: string }>;
    tbody: Array<{
      body: Array<{ value: string }>;
    }>;
  };
  instructionIcons?: Array<{
    filename: string;
    alt?: string;
  }>;
  brasBandTable?: {
    thead: Array<{ value: string }>;
    tbody: Array<{
      body: Array<{ value: string }>;
    }>;
  };
  brasCupTable?: {
    thead: Array<{ value: string }>;
    tbody: Array<{
      body: Array<{ value: string }>;
    }>;
  };
  pantiesUpdatedTable?: {
    thead: Array<{ value: string }>;
    tbody: Array<{
      body: Array<{ value: string }>;
    }>;
  };
  pantiesUpdatedDoubleSizeTable?: {
    thead: Array<{ value: string }>;
    tbody: Array<{
      body: Array<{ value: string }>;
    }>;
  };
  swimBottomUpdatedTable?: {
    thead: Array<{ value: string }>;
    tbody: Array<{
      body: Array<{ value: string }>;
    }>;
  };
}
